import formatFileSize from 'rebook/apps/utils/text/formatFileSize';
import { SOCIAL_NETWORKS } from 'rebook/apps/base/components/social/constants';
import { URLS } from 'rebook/apps/base/constants';


export const USERS_USER_SET = 'USERS_USER_SET';
export const USERS_USER_REMOVE = 'USERS_USER_REMOVE';

export const USERS_AUTHFORM_SHOW = 'USERS_AUTHFORM_SHOW';
export const USERS_AUTHFORM_HIDE = 'USERS_AUTHFORM_HIDE';

export const USERS_NOTIFICATION_POP = 'USERS_NOTIFICATION_POP';
export const USERS_NOTIFICATION_REMOVE = 'USERS_NOTIFICATION_REMOVE';

export const USERS_MODAL_DIALOG_POP = 'USERS_MODAL_DIALOG_POP';
export const USERS_MODAL_DIALOG_REMOVE = 'USERS_MODAL_DIALOG_REMOVE';

export const USERS_BOOKSHELF_DETAIL_SET_DATA = 'USERS_BOOKSHELF_DETAIL_SET_DATA';
export const USERS_BOOKSHELF_DETAIL_RESET_DATA = 'USERS_BOOKSHELF_DETAIL_RESET_DATA';

export const USERS_AUTH_LOGIN_NOTIFICATIONS = {
  RESET_PASSWORD_SUCCESS: '🎊 Ваш пароль изменен!',
  ERROR: '😞 Что-то пошло не так. Наши инженеры уже занимаются проблемой.',
  LOGOUT: '🏃‍ Вы успешно вышли из учетной записи',
  SUCCESS: '🎉 С возвращением!',
  SUCCESS_REGISTRATION: '🎉 Добро пожаловать в MyBook!',
};

export const MAX_IMAGE_FILE_SIZE = 1024 * 1024 * 5; // in bytes
export const MAX_BOOK_COVER_IMAGE_SIZE = Math.round(1024 * 1024 * 3); // in bytes

export const USER_SETTINGS_SUCCESS_MESSAGES = {
  USER_IMAGE_UPLOADED: 'Картинка загружена',
  USER_PERSONAL_DATA_UPDATED: 'Ваши имя и фамилия в MyBook изменены',
  USER_FIRST_NAME_UPDATED: 'Ваше имя в MyBook изменено',
  USER_LAST_NAME_UPDATED: 'Ваша фамилия в MyBook изменена',
  USER_PASSWORD_UPDATED: 'Пароль изменен',
  USER_EMAIL_UPDATED: 'E-mail изменен',
};

export const USER_SETTINGS_ERROR_MESSAGES = {
  INVALID_FILE_SIZE: `Картинка должна быть не более ${formatFileSize(MAX_IMAGE_FILE_SIZE)}`,
  INVALID_FILE_TYPE: 'Неверный формат картинки',
  PASSWORD_IS_REQUIRED: 'Заполните это поле',
  PASSOWRDS_MUST_NOT_MATCH: 'Пароли не должны совпадать',
  EMAIL_CHANGING_ERROR: 'Эта ссылка больше не работает',
};

export const WALLETS_DATA_SET = 'WALLETS_DATA_SET';

export const NOTIFICATION_DESTROY_TIMER = 2000;

export const SOCIAL_LOGINS = {
  facebook: {
    id: 1,
    name: SOCIAL_NETWORKS.FACEBOOK.name,
    icon: SOCIAL_NETWORKS.FACEBOOK.icon,
    slug: 'facebook',
    url: '/api/cb/social/login/facebook/',
    provider: 'facebook',
  },
  vkontakte: {
    id: 2,
    name: SOCIAL_NETWORKS.VK.name,
    icon: SOCIAL_NETWORKS.VK.icon,
    slug: 'vkontakte',
    url: '/api/cb/social/login/vkontakte-oauth2/',
    provider: 'vkontakte-oauth2',
  },
  googleplus: {
    id: 3,
    name: SOCIAL_NETWORKS.GOOGLEPLUS.name,
    icon: SOCIAL_NETWORKS.GOOGLEPLUS.icon,
    slug: 'googleplus',
    url: '/api/cb/social/login/google-oauth2/',
    provider: 'google-oauth2',
  },
  odnoklassniki: {
    id: 4,
    name: SOCIAL_NETWORKS.ODNOKLASSNIKI.name,
    icon: SOCIAL_NETWORKS.ODNOKLASSNIKI.icon,
    slug: 'odnoklassniki',
    url: '/api/cb/social/login/odnoklassniki/',
    provider: 'odnoklassniki',
  },
  twitter: {
    id: 5,
    name: SOCIAL_NETWORKS.TWITTER.name,
    icon: SOCIAL_NETWORKS.TWITTER.icon,
    slug: 'twitter',
    url: '/api/cb/social/login/twitter/',
    provider: 'twitter',
  },
  litres: {
    id: 6,
    name: SOCIAL_NETWORKS.LITRES.name,
    icon: SOCIAL_NETWORKS.LITRES.icon,
    slug: 'litres',
    url: '/api/cb/social/login/litres/',
    provider: 'litres',
  },
};

export const USER_SETTINGS_PAGES = [
  {
    id: 0,
    name: 'userProfile',
    label: 'Профиль',
    url: URLS.accountSettings,
  },
  {
    id: 1,
    name: 'userSubscriptionList',
    label: 'Подписка',
    url: URLS.accountSubscriptionList,
  },
];

export const BOOK_SHELF_EDIT = {
  BOOK_SHELVE_CREATED: (name) => `🎉 Поздравляем! Вы создали полку ${name}`,
  BOOK_SHELF_EDITED: (name) => `🤓 Готово! Полка “${name}” изменена`,
  BOOK_SHELF_COVER_IMAGE_TYPE_ERROR: '⚠️ Файл неправильного формата. Мы поддерживаем jpg и png.',
  BOOK_SHELF_COVER_IMAGE_SIZE_ERROR: `Картинка должна быть не более 3 Мб`,
  BOOKSHELF_NAME_IS_REQUIRED: 'Введите название',
};
